// Head-to-head scores are used; a league-median win is not a matchup win.
export function matchupResults(rows, rosters, completed) {
  const owners = new Map(rosters.map(r => [r.roster_id, r.owner_id]));
  const grouped = new Map();
  for (const row of rows) {
    if (row.matchup_id == null) continue;
    const group = grouped.get(row.matchup_id) || [];
    group.push(row);
    grouped.set(row.matchup_id, group);
  }
  return [...grouped].sort(([a], [b]) => a - b).map(([id, group]) => {
    const teams = group.sort((a,b) => a.roster_id - b.roster_id).map(row => ({
      id: owners.get(row.roster_id), score: row.custom_points ?? row.points,
    }));
    const ready = completed && teams.length === 2 && teams.every(t => t.id && typeof t.score === 'number' && Number.isFinite(t.score));
    const tied = ready && teams[0].score === teams[1].score;
    return { id, teams, tied, winnerId: ready && !tied ? teams[teams[0].score > teams[1].score ? 0 : 1].id : null };
  });
}

export function calculatePickemWinner(cards, winnerIds, matchupCount, tiebreaker) {
  if (!matchupCount || winnerIds.length !== matchupCount || tiebreaker === '' || tiebreaker == null || !Number.isFinite(Number(tiebreaker))) return null;
  const valid = cards.filter(c => Array.isArray(c.Ids) && c.Ids.length === matchupCount && new Set(c.Ids).size === matchupCount && c.Ids.includes(c.Lock) && c.TieBreaker !== '' && c.TieBreaker != null && Number.isFinite(Number(c.TieBreaker)));
  if (!valid.length) return null;
  const scored = valid.map(card => ({ card, score: card.Ids.filter(id => winnerIds.includes(id)).length + (winnerIds.includes(card.Lock) ? 1 : -1), distance: Math.abs(Number(card.TieBreaker) - Number(tiebreaker)) }));
  scored.sort((a,b) => b.score - a.score || a.distance - b.distance);
  const top = scored[0];
  // Do not invent a policy for a tie that the recorded tiebreaker cannot settle.
  if (scored[1]?.score === top.score && scored[1]?.distance === top.distance) return null;
  return [top.card.Tid, top.score === matchupCount + 1 ? 10 : 5];
}
